import { v1 } from 'uuid';

function generateNonce(): string {
  return v1();
}

export default generateNonce;
